export const lbsToKg = (lbs = 0) => (lbs * 0.453592)?.toFixed(2);
export const kgToLbs = (kg = 0) => (kg * 2.20462)?.toFixed(2);
export const cmToInches = (cm = 0) => (cm / 2.54)?.toFixed(2);
export const inchesToCm = (inches = 0) => (inches * 2.54)?.toFixed(2);

export const formatWeight = (unit, weightInKg = 0) => {
  if (unit === "imperial") {
    const weightInLbs = kgToLbs(weightInKg);
    return `${weightInLbs} lbs`;
  } else {
    return `${weightInKg?.toFixed(2) || 0} kg`;
  }
};

export const formatMeasurement = (unit, value = 0) => {
  if (unit === "imperial") {
    const inches = cmToInches(value);
    return `${inches} inch`;
  }
  return `${value} cm`;
};

// added for edit weight goal
export const getWeightByUnit = (unit, weightInKg = 0) => {
  return unit === "imperial" ? kgToLbs(weightInKg) : weightInKg.toFixed(2);
};
